<template>
	<div>
		<div class="signing-top">
			<div class="top">
				<div class="content">
					<h1>{{$t('review-sign.contract.headline') }}</h1>
					<p>{{ getSigningPropertyAddress }}</p>
				</div>
				<a :href="signatureUrl" class="button purple">{{$t('button.continue') }}</a>
			</div>
			<div class="progress-bar">
				<div class="content">
					<div class="col done">
						<div class="dot">
							<svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
							  <path class="fill-white" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
							</svg>
						</div>
						<p>{{$t('review-sign.steps.info') }}</p>
					</div>
					<div class="col done">
						<div class="dot">
							<svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
							  <path class="fill-white" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
							</svg>
						</div>
						<p>{{$t('review-sign.steps.review') }}</p>
					</div>
					<div class="col active">
						<div class="dot"></div>
						<p>{{$t('review-sign.steps.electricity') }}</p>
					</div>
					<div class="col">
						<div class="dot"></div>
						<p>{{$t('review-sign.steps.sign') }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="signing-content">
			<div class="content-box small">
				<div>
					<h2>{{$t('review-sign.power-supply.headline')}}</h2>
					<p>{{$t('review-sign.power-supply.text')}} </p>

					<div class="large-selectors">
						<input name="power_supply_mode" type="radio" id="automatic" value="simplex" v-model="power_supply_mode">
						<div class="selector">
							<label for="automatic" class="wrapper">
								<div class="content">
									<h2>{{$t('power-supply.automatic.headline')}}</h2>
									<p>{{$t('power-supply.automatic.text')}}</p>
									<div class="by">
										<span>{{$t('power-supply.supplier.label')}}</span>
										<img src="/images/img/supplier.png">
									</div>
								</div>
								<div class="info">
									<div class="select-box">
										<SvgIcon icon="white-checkmark" />
									</div>
									<div class="illustration">
										<button v-if="power_supply_mode != 'simplex' && !showDetails" class="transparent" @click="openDetails">
											{{ $t('global.label.more-details') }}
										</button>
										<button v-if="power_supply_mode != 'simplex' && showDetails" class="transparent" @click="closeDetails">
											{{ $t('global.label.less-details') }}
										</button>
										<SvgIcon icon="power-auto" />
									</div>
								</div>
							</label>
							<div class="info-content" v-show="showDetails || power_supply_mode === 'simplex'">
				            	<div class="col">
				            		<img src="/images/img/nrgi-logo.png" class="small-logo">
				            		<h3>{{$t('power-supply.modal-content.headline')}}</h3>
				            		<p>{{$t('power-supply.modal-content.text')}}</p>
				            		<ul>
				            			<li>
					            			<SvgIcon icon="white-checkmark" />
					            			<p>{{$t('power-supply.modal-content.list1')}}</p>
					            		</li>
					            		<li>
					            			<SvgIcon icon="white-checkmark" />
					            			<p>{{$t('power-supply.modal-content.list2')}}</p>
					            		</li>
					            		<li>
					            			<SvgIcon icon="white-checkmark" />
					            			<p>{{$t('power-supply.modal-content.list3')}}</p>
					            		</li>
					            		<li>
					            			<SvgIcon icon="white-checkmark" />
					            			<p>{{$t('power-supply.modal-content.list4')}}</p>
					            		</li>
				            		</ul>
				            	</div>
				            	<div class="col">
				            		<div class="box text-center">
				            			<img src="/images/img/trustpilot.png">
				            			<p><span class="bold">{{$t('power-supply.modal-content.label1')}}</span> {{$t('power-supply.modal-content.label2')}}</p>
				            		</div>
				            		<div class="box">
				            			<p><span class="bold">{{ $t('power-supply.modal-content.price-label') }}</span></p>
				            			<a href="https://nrgi.dk/privat/priser/" target="_blank">
					            			{{$t('power-supply.modal-content.price-link')}}
					            		</a>
					            		<p>{{ $t('power-supply.modal-content.price-text1') }} {{ power_supply_abonnement }}</p>
					            		<p>{{ $t('power-supply.modal-content.price-text2') }}</p>
				            		</div>

			            			<div class="button-container">
			            				<a href="https://nrgi.dk/privat/priser/vores-priser-og-produkter/bevar-mig-el/"  target="_blank" class="button transparent">
					            			{{$t('power-supply.modal-content.button1')}}
					            		</a>
				            			<a href="https://nrgi.dk/media/3245/20201028_leveringsbetingelser_nrgi_privat.pdf" target="_blank" class="button transparent">
				            				{{$t('power-supply.modal-content.button2')}}
				            			</a>
			            			</div>
				            	</div>
				            </div>
			            </div>
						<input name="power_supply_mode" type="radio" id="manually" value="manual" v-model="power_supply_mode">
						<div class="selector" @click="closeDetails">
							<label for="manually" class="wrapper">
								<div class="content">
									<h3>{{$t('power-supply.manually.headline')}}</h3>
									<p>{{$t('power-supply.manually.text')}}</p>
								</div>
								<div class="info">
									<div class="select-box">
										<SvgIcon icon="white-checkmark" />
									</div>
									<div class="illustration">
										<SvgIcon icon="power-manual" />
									</div>
								</div>
							</label>
							<label for="acceptTerms" class="bottom" v-if="power_supply_mode === 'manual'">
								<div class="custom-checkbox">
		                            <input type="checkbox" id="acceptTerms" v-model="acceptTerms">
		                            <div class="checkbox">
		                                <svg xmlns="http://www.w3.org/2000/svg"  width="9.895" height="7.38" viewBox="0 0 19.79 14.76">
		                                    <path class="fill-checkmark" d="M1330.31,1086.51l-10.8,10.8a2.256,2.256,0,0,1-3.02,0l-4.8-4.8a1.994,1.994,0,1,1,2.82-2.82l3.49,3.48,9.49-9.48A1.994,1.994,0,1,1,1330.31,1086.51Z" transform="translate(-1311.12 -1083.12)"/>
		                                </svg>
		                            </div>
		                            <p>{{$t('power-supply.manually.terms')}}</p>
	 							</div>
							</label>
						</div>
						<div class="button-container">
							<!-- Onclick remember if power_supply_mode -->
							<a :href="signatureUrl">
                                <button class="button purple" :disabled="!power_supply_mode || power_supply_mode === 'manual' && !acceptTerms">
                                    {{ $t('review.continue-to-signature') }}
                                </button>
                            </a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <Modal v-if="showDetails">
			<div class="modal-container large-modal" slot="modal-container">
				<div class="close" @click="openDetails">
	                <SvgIcon icon="close"/>
	            </div>
	            <div class="modal-content">
	            	<div class="col">
	            		<h3>{{$t('power-supply.modal-content1.headline')}}</h3>
	            		<p>{{$t('power-supply.modal-content1.text')}}</p>
	            	</div>
	            	<div class="col">
	            		<div class="box text-center">
	            			<p>{{$t('power-supply.supplier.label')}}</p>
	            			<img src="/images/img/nrgi-logo.png">
	            			<img src="/images/img/TrustPilot.png">
	            			<p>{{$t('power-supply.modal-content1.label1')}}</p>
	            			<p>{{$t('power-supply.modal-content1.label2')}}</p>
	            		</div>
	            	</div>
	            </div>
	            <div class="modal-content">
	            	<div class="col">
	            		<img src="/images/img/nrgi-logo.png" class="small-logo">
	            		<h3>{{$t('power-supply.modal-content2.headline')}}</h3>
	            		<p>{{$t('power-supply.modal-content2.text')}}</p>
	            		<ul>
	            			<li>
		            			<SvgIcon icon="white-checkmark" />
		            			<p>{{$t('power-supply.modal-content2.list1')}}</p>
		            		</li>
		            		<li>
		            			<SvgIcon icon="white-checkmark" />
		            			<p>{{$t('power-supply.modal-content2.list2')}}</p>
		            		</li>
		            		<li>
		            			<SvgIcon icon="white-checkmark" />
		            			<p>{{$t('power-supply.modal-content2.list3')}}</p>
		            		</li>
		            		<li>
		            			<SvgIcon icon="white-checkmark" />
		            			<p>{{$t('power-supply.modal-content2.list4')}}</p>
		            		</li>
	            		</ul>
	            	</div>
	            	<div class="col">
	            		<div class="box">
	            			<p class="price">{{$t('power-supply.modal-content2.price')}}</p>
	            			<p>{{$t('power-supply.modal-content2.label1')}}</p>
	            			<p>{{$t('power-supply.modal-content2.label2')}}</p>
	            			<div class="info-container">
	            				<SvgIcon icon="leaf" />
	            				<SvgIcon icon="leaf" />
	            				<div class="tip">
	            					<div class="icon">
	            						<SvgIcon icon="question-mark" />
	            						<p>{{$t('power-supply.modal-content2.tip-label')}}</p>
	            					</div>
	            					<div class="tip-box">
	            						<p>{{$t('power-supply.modal-content2.tip-text')}} <a href="#">{{$t('power-supply.modal-content2.tip-link')}}</a></p>
	            					</div>
	            				</div>
	            			</div>
	            			<a href="https://nrgi.dk/privat/priser/" target="_blank" class="button transparent">{{$t('power-supply.modal-content2.button1')}}</a>
	            		</div>
	            		<div class="button-container">
	            			<a href="https://nrgi.dk/privat/priser/vores-priser-og-produkter/bevar-mig-el/" class="button transparent">{{$t('power-supply.modal-content2.button2')}}</a>
	            			<a href="https://nrgi.dk/media/3245/20201028_leveringsbetingelser_nrgi_privat.pdf" target="_blank" class="button transparent">{{$t('power-supply.modal-content2.button3')}}</a>
	            		</div>
	            	</div>
	            </div>
	        </div>
		</Modal> -->
	</div>
</template>
<script>

    import {store} from "../../store";
    import {mapGetters} from "vuex";
    import Logo from '../../components/Logo';
    import SvgIcon from '../../components/Svg.vue';
    export default {
        data: () => ({
        	power_supply_mode: '',
            power_supply_abonnement: '',
			showDetails: false,
			acceptTerms: false
        }),
        components: {
        	Logo,
        	SvgIcon
        },
        computed: {
        	...mapGetters([
        		'getToken',
        		'getSingleDraftContract',
        		'getSigningPropertyAddress',
        		'getSigningContractId',
        		'getSigningContractTenantForReview',
        		'getSigningContractLandlordForReview'
        	]),
        	signatureUrl() {
        		return '/signing/' + this.$route.params.id;
        	}
        },
        methods: {
        	openDetails: function(){
                this.showDetails = true
            },
            closeDetails: function(){
            	this.showDetails = false
            }
        },
        created() {
            if(this.getSingleDraftContract === null) {
                this.$store.dispatch('fetchSingleDraftContract', {id: this.getSigningContractId});
            }

            axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/settings'
            }).then(response => {
                this.power_supply_abonnement = response.data.power_supply.price.abonnement;
            }).finally(() => {
                this.loading = false;
            });
        },
        watch: {
            power_supply_mode: function (value) {
                let draftContract = this.getSingleDraftContract;
                draftContract.power_supply_mode = this.power_supply_mode;
                this.$store.commit('setSingleDraftContract', draftContract);

                axios({
                    method: 'PATCH',
                    url: `${window.config.apiUrl}api/draft-contract/${this.getSigningContractId}/power-supply`,
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        power_supply_mode: this.power_supply_mode
                    }
                });
            }
        }
    }

</script>
<style></style>
